// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-laptop-travel-bag-tactical-waterproof",
  "entries": [
    {
      "id": "24115977027774",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-24115977027774.jpg?v=1769483317",
      "alt": "laptoptasche 14 zoll"
    },
    {
      "id": "30984114208958",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Laptop-Travel-Bag-Tactical-Waterproof-L-Military-Bag-Rucking-Seibertron-30984114208958.png?v=1769481418",
      "alt": "laptop rucksack wasserdicht"
    },
    {
      "id": "28646174523582",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-28646174523582.jpg?v=1769483317",
      "alt": "laptoptasche 15 6 zoll"
    },
    {
      "id": "28646174818494",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-28646174818494.jpg?v=1769483317",
      "alt": "rucksack laptop herren"
    },
    {
      "id": "24115976175806",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-24115976175806.jpg?v=1769483317",
      "alt": "rucksack laptop wasserdicht"
    },
    {
      "id": "30984053817534",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-30984053817534.png?v=1769483317",
      "alt": "rucksack laptop wasserdicht"
    },
    {
      "id": "28646174458046",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-28646174458046.jpg?v=1769483317",
      "alt": "rucksack wasserdicht laptop"
    },
    {
      "id": "28646174425278",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-28646174425278.jpg?v=1769483317",
      "alt": "14 zoll laptoptasche"
    },
    {
      "id": "28646174556350",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-28646174556350.jpg?v=1769483317",
      "alt": "15 6 zoll laptoptasche"
    },
    {
      "id": "28646174392510",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-28646174392510.jpg?v=1769483317",
      "alt": "laptop 14 zoll tasche"
    },
    {
      "id": "24008385298622",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-24008385298622.jpg?v=1769483317",
      "alt": "wasserdichte laptop rucksäcke"
    },
    {
      "id": "28646174490814",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-28646174490814.jpg?v=1769483317",
      "alt": "wasserdicht rucksack laptop"
    },
    {
      "id": "28646174785726",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-28646174785726.jpg?v=1769483317",
      "alt": "laptoptasche für 15 6 zoll"
    },
    {
      "id": "24135578058942",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-24135578058942.jpg?v=1769483317",
      "alt": "Sling bag with Molle straps for easy attachment of tactical accessories."
    },
    {
      "id": "24135577501886",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Tactical-Laptop-Backpack-Waterproof-Molle-Tactical-Laptop-Sling-Rucking-BAG-Seibertron-24135577501886.jpg?v=1769483317",
      "alt": "Waterproof tactical sling bag ideal for daily commuting and urban use."
    },
    {
      "id": "30984181711038",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Laptop-Travel-Bag-Tactical-Waterproof-L-Military-Bag-Rucking-Seibertron-30984181711038.png?v=1769481431",
      "alt": "Seibertron Laptop Travel Bag Tactical Waterproof L– Military Bag Rucking - Seibertron"
    },
    {
      "id": "30984182202558",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Laptop-Travel-Bag-Tactical-Waterproof-L-Military-Bag-Rucking-Seibertron-30984182202558.png?v=1769481431",
      "alt": "Seibertron Laptop Travel Bag Tactical Waterproof L– Military Bag Rucking - Seibertron"
    }
  ],
  "variants": [
    {
      "id": "45338325254334",
      "title": "Khaki Max Suitable 15.6\"laptop",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Khaki Max Suitable 15.6\"laptop"
        }
      ],
      "values": [
        "Khaki Max Suitable 15.6\"laptop"
      ],
      "mediaId": "24115977027774"
    },
    {
      "id": "45338325221566",
      "title": "Black Max Suitable 15.6\"laptop",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black Max Suitable 15.6\"laptop"
        }
      ],
      "values": [
        "Black Max Suitable 15.6\"laptop"
      ],
      "mediaId": "24115976175806"
    },
    {
      "id": "45338325156030",
      "title": "Black Max Suitable 14.1\"laptop",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black Max Suitable 14.1\"laptop"
        }
      ],
      "values": [
        "Black Max Suitable 14.1\"laptop"
      ],
      "mediaId": "30984181711038"
    },
    {
      "id": "45338325188798",
      "title": "Khaki Max Suitable 14.1\"laptop",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Khaki Max Suitable 14.1\"laptop"
        }
      ],
      "values": [
        "Khaki Max Suitable 14.1\"laptop"
      ],
      "mediaId": "30984182202558"
    },
    {
      "id": "45338325287102",
      "title": "1 piece of luggage strap black",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "1 piece of luggage strap black"
        }
      ],
      "values": [
        "1 piece of luggage strap black"
      ],
      "mediaId": "24135577501886"
    },
    {
      "id": "45338325319870",
      "title": "1 piece of luggage strap khaki",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "1 piece of luggage strap khaki"
        }
      ],
      "values": [
        "1 piece of luggage strap khaki"
      ],
      "mediaId": "24135578058942"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {},
  "optimizeColorSwatches": false,
  "forceExactColorSwatches": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function syncApprovedDescriptionCopy(scope) {
    if (config.handle !== 'seibertron-motorbike-backpack-motorcycle-bag-outdoor-sports-riding-package') return;
    var oldOpening = 'Ultimate Water-Resistant Backpack: Built with durable 900D waterproof fabric, this backpack is designed for riders and outdoor users who need dependable everyday protection from light rain and road spray.';
    var oldNote = 'Water-Resistance Note: The 900D fabric is waterproof, but the complete backpack is water resistant rather than fully waterproof because zippers and stitch openings can allow moisture through. Always close the backpack securely to help keep gear dry.';
    var oldHighlight = '900D waterproof fabric and water-resistant backpack construction help protect gear in everyday conditions.';
    Array.prototype.slice.call(scope.querySelectorAll('p')).forEach(function (paragraph) {
      var text = String(paragraph.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === oldOpening) {
        paragraph.innerHTML = '<strong>Introducing the Ultimate Water Resistant Backpack!</strong> Made from durable 900D water resistant material, this backpack is perfect for outdoor enthusiasts who need reliable protection from the elements ...';
      } else if (text === oldNote) {
        paragraph.innerHTML = '<strong>Water Resistance Note:</strong> The backpack uses water resistant 900D material and construction for everyday protection. Moisture can still pass through zippers and stitch openings, so it is not designed for submersion. Always close the backpack securely to help keep gear dry.';
      }
    });
    Array.prototype.slice.call(scope.querySelectorAll('li')).forEach(function (item) {
      var text = String(item.textContent || '').replace(/\s+/g, ' ').trim();
      var replacement = {
        '37L capacity organizes riding gear, outdoor equipment, and daily essentials.': '900D coated fabric, durable SBS zippers, and secure KAM buckles provide water-resistant, abrasion-resistant construction for demanding daily use.',
        'Durable 900D water resistant material and backpack construction help protect gear in everyday conditions.': 'MOLLE webbing, shoulder-strap D-rings, bottom straps, and a top carry handle expand options for small gear, a water bottle, a sleeping pad, or a sleeping bag.',
        '900D waterproof fabric and water-resistant backpack construction help protect gear in everyday conditions.': 'MOLLE webbing, shoulder-strap D-rings, bottom straps, and a top carry handle expand options for small gear, a water bottle, a sleeping pad, or a sleeping bag.',
        'MOLLE webbing plus adjustable chest and waist straps support organized, secure carry.': 'A load-supporting, heat-dissipating back system, adjustable chest strap (up to 60 in), and hydration-hose keeper support comfortable carry; the rescue whistle can help attract attention in an emergency.'
      }[text];
      if (replacement) item.textContent = replacement;
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      if (config.forceExactColorSwatches && optionName === 'Color') {
        var shell = choice.querySelector('[data-auto-choice-label]') || choice;
        var expectedSrc = sized(entry.src, 180);
        var existingImage = shell.querySelector('img');
        if (!(existingImage && existingImage.src === expectedSrc && existingImage.alt === input.value)) {
          shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(input.value || entry.alt || '') + '"><img src="' + escapeHtml(expectedSrc) + '" alt="' + escapeHtml(input.value || entry.alt || '') + '" width="72" height="72" loading="eager"></span><span class="auto-product__swatch-label">' + escapeHtml(input.value || '') + '</span>';
        }
        choice.setAttribute('data-variant-media-id', entry.id);
        choice.setAttribute('data-falcon-full-gallery-swatch-media-id', entry.id);
        return;
      }
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var isDesired = config.entries.some(function (entry) { return entry.id === thumb.getAttribute('data-media-id'); });
      thumb.hidden = !isDesired;
      thumb.style.display = isDesired ? '' : 'none';
      thumb.setAttribute('aria-hidden', isDesired ? 'false' : 'true');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncApprovedDescriptionCopy(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) {
        return record.type === 'attributes' || record.addedNodes.length || record.removedNodes.length;
      });
      if (changed) window.setTimeout(hydrate, 0);
    });
    observer.observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-safe-gallery-media-ids', 'src', 'srcset', 'data-variant-media-id']
    });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
